/**
 * Вывод Full HD 1920×1080: HUD, надписи и меню рисуются в полном разрешении.
 * Сетка арта 960×540: пиксель героя и эффектов — 2×2 точки экрана (×2 на 1080p, ×4 на 4K), только целый масштаб.
 */
export const SCREEN_W = 1920;
export const SCREEN_H = 1080;
export const ART_SCALE = 2;
export const ART_W = SCREEN_W / ART_SCALE;
export const ART_H = SCREEN_H / ART_SCALE;
/** Пол в сетке арта. */
export const ART_FLOOR = 492;

/**
 * Мир считает в своих единицах (подпиксели 1/256); в сетку арта они переходят ×1,25. Манекен — 152 единицы мира,
 * 190 пикселей арта, 380 точек экрана: 35 % высоты.
 */
export const WORLD_TO_ART = 1.25;
/** Ширина всей арены мира и её же в пикселях арта (камера показывает ART_W). */
export const ARENA_WORLD_W = 960;
export const ARENA_ART_W = ARENA_WORLD_W * WORLD_TO_ART;

export const toArtX = (worldX: number): number => Math.round(worldX * WORLD_TO_ART);
export const toArtY = (worldY: number): number => ART_FLOOR + Math.round(worldY * WORLD_TO_ART);
